import { get } from "lodash";

export const getFieldValueByKey = (
  fieldKey: string,
  formValues: Record<string, any>
): any => {
  return get(formValues, fieldKey, null);
};
